<template>
  <div class="hello flex">
    <volLeft :data='customCheckDetail'></volLeft>
    <div class="right">
      <main>

        <!-- <div class="tablehead flex">
          <span style="width:70px;">录取概率</span>
          <span style="width: 270px;">院校名称</span>
          <div style="width: 600px;" class="history_data">
            <div class="line1">历史数据</div>
            <div class="line2">
              <span style="width: 60px">年份</span>
              <span style="width: 70px">预测冲</span>
              <span style="width: 70px">预测稳</span>
              <span style="width: 70px">预测保</span>
              <span style="width: 90px">实际录取分
              </span>
              <span style="width: 70px">线差</span>
              <span style="width:70px">位次</span>
            </div>
          </div>
        </div> -->
        <div class="tablehead flex">
          <span style="width:70px;">录取概率</span>
          <span style="width: 300px;">院校名称</span>
          <div style="width: 600px;text-align: center;">
            历史数据
          </div>
        </div>
        <div class="tablemain">

          <el-collapse accordion>
            <el-collapse-item style="height: 100%;" v-for="(item,index0) in data" :key="index0" :name=index0>
              <template slot="title">
                <div class="flex tableone">
                  <div style="width: 70px;">
                    <p><span style="font-size: 18px;">{{item.rate}}</span>%</p>
                    <span v-if="item.rate<10">风险极大</span>
                    <span v-if="item.rate>10&&item.rate<70">风险适中</span>
                    <span v-if="item.rate>70">风险较小</span>
                    <p v-if="item.rate<10" class="lei">冲</p>
                    <p v-if="item.rate>10&&item.rate<70" class="lei" style="background-color: orange;">稳</p>
                    <p v-if="item.rate>70" class="lei" style="background-color: #19CACA;">保</p>
                  </div>
                  <div class="info flex" style="justify-content: flex-start;flex-wrap: nowrap;width: 270px;"
                    @click.stop="jump(item)">
                    <img :src="'https://yunzhixuanpro.fw366.cn/'+item.school_info.badge_img" alt="">
                    <div style="text-align: left">
                      <div><span class="name">{{item.school_name}}</span>
                        <!-- <span class="name" style="font-size: 14px;">(院校代码：{{item.id}})</span> -->
                      </div>
                      <div style="color: #C10B17;line-height: 12px;font-size: 12px;">
                        {{item.examinee_type=='普通类'?'':'('+item.examinee_type+')'}}
                      </div>
                      <div style="height:30px;"><span>招生代码:{{item.enroll_code}}</span></div>
                      <div style="height:30px;">
                        <span> 主管部门:{{item.school_info.management}}</span>
                      </div>
                      <div>
                        <span>{{item.school_info.province_name}}-{{item.school_info.city_name}}</span>
                        <span>{{item.school_info.type}}</span>
                        <span>{{item.is_211==1?'211':''}}</span>
                        <span>{{item.is_985==1?'985':''}}</span>
                      </div>

                    </div>
                  </div>

                  <div class="score_table flex">
                    <div class="line2 flex">
                      <div style="display: block;
                    margin: 5px auto;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;width: 60px;">
                        年份
                      </div>
                      <div style="display: block;
                      margin: 5px auto;
                      height: 24px;
                      line-height: 24px;
                      text-align: center;
                      width: 70px;">
                        预测冲
                      </div>
                      <div style="display: block;
                        margin: 5px auto;
                        height: 24px;
                        line-height: 24px;
                        text-align: center;width: 70px;">
                        预测稳
                      </div>
                      <div style="display: block;
                          margin: 5px auto;
                          height: 24px;
                          line-height: 24px;
                          text-align: center;width: 70px;">
                        预测保
                      </div>
                      <div style="display: block;
                            margin: 5px auto;
                            height: 24px;
                            line-height: 24px;
                            text-align: center;width: 104px">
                        实际录取分
                      </div>
                      <div style="display: block;
                              margin: 5px auto;
                              height: 24px;
                              line-height: 24px;
                              text-align: center;width: 70px">
                        线差
                      </div>
                      <div style="display: block;
                              margin: 5px auto;
                              height: 24px;
                              line-height: 24px;
                              text-align: center;width: 70px">
                        位次
                      </div>
                    </div>
                    <div class="" style="width: 60px;">
                      <div v-for="(item,index) in item.history" style="display: block;
                   margin: 5px auto;
                   width: 24px;
                   height: 24px;
                   line-height: 24px;
                   text-align: center;">
                        {{item.year}}
                      </div>
                    </div>
                    <div class="history" style="width: 70px;color: red;margin-right: 5px;">
                      <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
                        <span style="flex:1;text-align: center;">{{item1.score_danger==0?'-':item1.score_danger}}
                        </span>
                      </div>
                      <div v-else>
                        暂无数据
                      </div>
                    </div>
                    <div class="history" style="width: 70px;color: red;">
                      <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
                        <span style="flex:1;text-align: center;">{{item1.score_safe==0?'-':item1.score_safe}}
                        </span>
                      </div>
                      <div v-else>
                        暂无数据
                      </div>
                    </div>
                    <div class="history" style="width: 70px;color: red;">
                      <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
                        <span style="flex:1;text-align: center;">{{item1.score_guarantee==0?'-':item1.score_guarantee}}
                        </span>
                      </div>
                      <div v-else>
                        暂无数据
                      </div>
                    </div>
                    <div class="history" style="width: 90px;color: red;margin-right: 15px;color:#19CACA;">
                      <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
                        <span style="flex:1;text-align: center;">{{item1.score_actual==0?'-':item1.score_actual}}
                        </span>
                      </div>
                      <div v-else>
                        暂无数据
                      </div>
                    </div>
                    <div style="color:#19CACA;width:70px;" target="_blank">
                      <div v-for="(item1,index) in item.history" style="display: block;
                  margin: 5px auto;
                  width: 24px;
                  height: 24px;
                  line-height: 24px;
                  text-align: center;">
                        {{item1.score_actual!=null&&item.province_line!=null&&item1.score_actual!=0?item1.score_actual-item1.province_line:'-'}}
                      </div>
                    </div>
                    <div class="history" style="width: 70px;color:#19CACA;">
                      <div class="shuju1" v-for="(item1,index) in item.history" v-if="item.history.length!=0">
                        <span style="flex:1;text-align: center;">{{item1.score_rank==0?'-':item1.score_rank}}
                        </span>
                      </div>
                      <div v-else>
                        暂无数据
                      </div>
                    </div>
                    <!--
                    <span @click.stop="scoreShow(item,1)">录取分数</span>
                    <span @click.stop="scoreShow(item,2)">预测分数</span>
                    <div></div>
                    <span @click.stop="lookplan(item,1)">招生计划</span>
                    <span @click.stop="lookplan(item,2)">招生章程</span> -->
                  </div>
                  <div>
                    <!--填报为  -->
                    <!-- 填报为 -->
                    <!--填报为  -->
                    <div>
                      <el-dropdown trigger="click" @click.native.stop='stop()'>
                        <span class="el-dropdown-link" :class="[item.chekced==false?'':'checked']">

                          <span>志愿{{item.position}}</span>
                        </span>

                      </el-dropdown>
                    </div>
                    <p @click="tianbao(item,index0)">专业列表{{item.major_num}}</p>
                  </div>
                </div>
              </template>
              <!--填报为  -->
              <!--填报为  -->
              <!-- 填报为 -->
              <!-- 学校内专业 -->

              <div class="flex zhuanye_one" v-for="(item0,index) in tableData">
                <div class="flex" style="margin-left: 40px;">
                  <div>
                    <p><span style="font-size: 18px;">{{item0.rate}}</span>%</p>
                    <span v-show="item0.rate<=33">风险极大</span>
                    <span v-show="item0.rate<=66&&item0.rate>33">风险适中</span>
                    <span v-show="item0.rate>66">风险较小</span>
                  </div>
                  <div class="info flex"
                    style="justify-content: flex-start;flex-wrap: nowrap;width: 270px;margin-left: 30px;">
                    <div style="text-align: left">
                      <div><span class="name major_name">{{item0.major_name}}({{item0.major_detail}})</span>

                      </div>
                      <div class="type">
                        <span>学费:{{item0.money_year}}</span>
                        <span>学制:{{item0.school_year}}</span>
                        <span>招生人数:{{item0.num}}</span>

                      </div>
                      <div class="type">
                        <span>代码:{{item0.major_code}}</span>


                      </div>
                    </div>
                  </div>
                </div>
                <div class="zhuanye_shuju">
                  <div class="shuju_one">
                    <p class="flex"><span style="width: 60px;">年份</span><span style="width: 100px;">省控线</span><span
                        style="width: 100px;">录取最低分</span><span style="width: 100px;">最低位次</span><span
                        style="width: 100px;">线差</span></p>
                    <p class="flex" v-for="(item1,index) in item0.history_data">
                      <span style="width: 60px;">{{item1.year}}</span>
                      <span style="width: 100px;">{{item1.province_line}}</span>
                      <span style="width: 100px;">{{item1.score_actual==0?'-':item1.score_actual}}</span>
                      <span style="width: 100px;">{{item1.score_rank==0?'-':item1.score_rank}}</span><span
                        style="width: 100px;">{{item1.score_actual!=0&&item1.province_line!=0?item1.score_actual-item1.province_line:'-'}}</span>
                    </p>
                  </div>
                  <div class="shuju_one one1">
                    <p class="flex"><span style="width: 60px;">年份</span><span style="width: 100px;">预测冲刺</span><span
                        style="width: 100px;">预测稳妥</span><span style="width: 100px;">预测保底</span></p>
                    <p class="flex"><span style="width: 60px;">{{item.year}}</span><span
                        style="width: 100px;color: red;">{{item.score_danger}}</span><span
                        style="width: 100px;color: red;">{{item.score_safe}}</span><span
                        style="width: 100px;color: red;">{{item.score_guarantee}}</span></p>
                  </div>
                  <!-- <div class="shuju_one">
                    <p class="flex"><span style="width: 60px;">年份</span><span style="width: 100px;">省控线</span><span
                        style="width: 100px;">录取最低分</span><span style="width: 100px;">最低位次</span><span
                        style="width: 100px;">线差</span></p>
                    <p class="flex" v-for="(item1,index) in item0.history_data">
                      <span style="width: 60px;">{{item1.year}}</span>
                      <span style="width: 100px;">{{item1.province_line}}</span>
                      <span style="width: 100px;">{{item1.score_actual==0?'-':item1.score_actual}}</span>
                      <span style="width: 100px;">{{item1.score_rank==0?'-':item1.score_rank}}</span><span
                        style="width: 100px;">{{item1.score_actual!=0&&item1.province_line!=0?item1.score_actual-item1.province_line:'-'}}</span>
                    </p>
                  </div> -->
                </div>
                <div>

                  <button class="checked">专业{{index+1}}</button>

                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

        </div>
      </main>
    </div>
    <div id="mask" ref="mask" v-show="popupshow">

    </div>
    <!-- 确认填报信息弹框 -->

    <div class="popup1" v-show="popupshow">
      <div class="popuphead flex">
        <p>{{school.school_name}}
          <span style="font-size: 14px;margin: 0 12px;">
            <span style="color: #999999;">招生代码</span>
            {{school.enroll_code}}</span><span style="color: red;">*建议服从调剂！</span>
        </p><i class="el-icon-close" @click="popupshow=false"></i>
      </div>
      <div class="table1">
        <div class="tableHead1 flex">
          <span v-if="tableData.years.length!=0" :class="index==tabindex?'tabactive':''" @click="tabchange(item,index)"
            v-for="(item,index) in tableData.years">
            {{item.label}}历史录取
          </span>
        </div>
        <div style="width:1000px;margin: 1px auto;">
          <el-table max-height="450px" :data="tableList" border style="">
            <el-table-column prop="year" label="年份">
            </el-table-column>
            <el-table-column prop="major_name" label="名称">
            </el-table-column>
            <el-table-column label="位次">
              <template slot-scope="scope">
                <span>{{scope.row.rank==0?'暂无数据':scope.row.score_actual}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="enroll_code" label="招生代码">
              <template slot-scope="scope">
                <span
                  style="color: orange;text-align: center;">{{scope.row.enroll_code==0?'---':scope.row.enroll_code}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="score_actual" label="录取最低分">
              <template slot-scope="scope">
                <span>{{scope.row.score_actual==0?'暂无数据':scope.row.score_actual}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="score_pre_div" label="预测冲">
              <template slot-scope="scope">
                <span style="color: red;text-align: center;">{{scope.row.score_pre_div}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="score_add_avg" label="预测稳">
            </el-table-column>
            <el-table-column prop="score_add_div" label="预测保">
            </el-table-column>
            <el-table-column label="线差">
              <template slot-scope="scope">
                <span>{{scope.row.score_actual==0||scope.row.score_actual==null?'暂无数据':scope.row.score_actual-scope.row.province_line}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="score_actual" label="招生人数">
              <template slot-scope="scope">
                <span>{{scope.row.enroll_plan==0?'暂无数据':scope.row.enroll_plan}}</span>
              </template>
            </el-table-column> -->
            <el-table-column fixed="right" label="招生计划" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click='lookplan(scope.row,1)'>
                  <el-popover placement="bottom" title="标题" width="200" trigger="click" :content=popover_content>
                    <div style="color: red;">{{tip}}</div>
                    <span>{{popover_content}}</span>
                    <el-button slot="reference">查看</el-button>
                  </el-popover>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-popover placement="top" width="160" v-model="scope.row.visible">
                  <div style="color: red;">{{tip}}</div>
                  <span>{{popover_content}}</span>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.visible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="surezhuanye(scope.row,0)">确定</el-button>
                  </div>
                  <span slot="reference" @click="tianbaozhuanye(item,scope.row)"
                    v-if="zhuanye.indexOf(scope.row.mid+'')==-1">
                    填报
                  </span>
                </el-popover>
                <span style="color: #19CACA;" v-if="zhuanye.indexOf(scope.row.mid+'')!=-1"
                  @click=" tianbaozhuanye(scope.row)">
                  已填报
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: left;margin-top: 20px;" background layout="prev, pager, next"
            :total="zhuanye_total" hide-on-single-page @current-change="current_change" :current-page="zhuanye_page">
          </el-pagination>
          <div style="text-align: center;margin-top: 30px;">
            <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">重置</el-button>
            </el-button> -->
            <el-button style="width: 200px;
      background: #19CACA;
      border-radius: 4px;color: #FFFFFF;" @click="savezhuanye">保存</el-button>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 录取分数 -->
    <el-dialog title="录取分数" :visible.sync="score_show">
      <el-table :data="oldscore">
        <el-table-column property="year" label="年份"></el-table-column>
        <el-table-column property="score_danger" label="预测冲刺分"></el-table-column>
        <el-table-column property="score_safe" label="预测稳妥分"></el-table-column>
        <el-table-column property="score_guarantee" label="预测保底分"></el-table-column>
        <el-table-column property="score_actual" label="实际录取分"></el-table-column>
        <el-table-column property="province_line" label="省控线"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="预测分数" :visible.sync="forecastScore_show">
      <el-table :data="forecastScore">
        <el-table-column property="year" label="年份"></el-table-column>
        <el-table-column property="score_danger" label="预测冲刺分"></el-table-column>
        <el-table-column property="score_safe" label="预测稳妥分"></el-table-column>
        <el-table-column property="score_guarantee" label="预测保底分"></el-table-column>
      </el-table>
    </el-dialog>
    <!--  -->
  </div>
</template>

<script>
  import open from '../../components/open.vue'
  import popup from '../../components/popup.vue'
  import schoolFilter from '../../components/schoolfilter.vue'
  import volLeft from '../../components/volLeft.vue'
  export default {
    data() {
      return {
        type: '展开志愿表',
        filterConditions: {
          province_id: [],
          school_type: "",
          is_985: '',
          is_211: '',
          batch_name: '',
          school_name: '',
          school_category: '',
          page: 1,
          mode: 'danger'
        },
        add: true,
        record: [],
        popupshow: false,
        tabindex: 0,
        rangevalue: [],
        formInline: {
          user: '',
          region: ''
        },
        marks: {

        },
        tab_select: [],
        tab_type: 'school',
        data: [],
        zhuanye_total: 0,
        zhuanye_page: 1,
        forecastScore_show: false,
        forecastScore: [],
        page: 1,
        current: 1,
        activeName: 'first',
        dialogTableVisible: false,
        dialogTableVisible1: false,
        radio: 2,
        userInfo: [],
        options: [],
        batch: '',
        id: '',
        loading: false,
        school_id: '',
        school_pos: '',
        school: [],
        tableData: [],
        tableList: [],
        checkedSchool: [],
        popover_content: '',
        zhuanye: [],
        checkedSchool: [],
        checkedId: [],
        old: [], //最开始的数据
        one_major: [],
        score: '',
        userInfo: [],
        year: 2021,
        page: 1,
        id: '',
        customCheckDetail: [],
        onscroll: true,
        score_show: false,
        oldscore: [],
        max: 600,
        min: 500,
        checkMajor: [],
        max_major_num: ''
      }
    },
    components: {
      popup,
      schoolFilter,
      volLeft,
      open
    },
    created() {
      if (localStorage.getItem('token')) {
        this.$http.getUserInfo().then(res => {
          this.userInfo = res.data
        })
      } else {
        this.$message.warning('请先登录')
        this.$store.commit('login', true)
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.add = false
        this.filterConditions.batch_name = this.$route.query.batch
        this.getData()

        this.$http.checkSchoolSimulated().then(res => {
          this.options = res.data.list
        })

      }
    },
    mounted() {
      this.$nextTick(function() {
        window.addEventListener('scroll', this.onScroll)
      })
    },
    methods: {
      /* 模式切换*/
      modeChange(mode) {
        this.onscroll = false
        this.filterConditions.mode = mode
        this.filterConditions.page = 1
        this.id = this.$route.query.id
        this.add = false
        this.filterConditions.batch_name = this.$route.query.batch
        this.$http.checkSchoolCustomSearch(this.filterConditions).then(res => {
          this.data = res.data.list
          this.rangevalue = [res.data.score_min, res.data.score_max]
          this.max = res.data.score_max
          this.min = res.data.score_min
          this.data.forEach(item => {
            item.history_list.reverse()
          })
          this.data.forEach(item => {
            item.history_list.unshift({
              'score_actual': item.score_actual,
              'score_danger': item.score_danger,
              'score_safe': item.score_safe,
              'score_guarantee': item.score_guarantee,
              'year': item.year,
              "province_line": item.province_line,
              'score_rank': item.score_rank,
              'enroll_plan': item.enroll_plan
            })
          })
        })

        this.$http.checkSchoolSimulated().then(res => {
          this.options = res.data.list
        })
        this.$forceUpdate()
      },
      getData() {
        this.$http.customCheckDetail({
          id: this.$route.query.id
        }).then(res => {
          this.customCheckDetail = res.data
          this.data = res.data.detail
          this.checkedSchool = res.data.detail.map(item => {
            return item.algorithm_school_id
          })
          let resData = res.data.detail

          for (let i = 0; i < resData.length; i++) {
            for (let p = 0; p < this.data.length; p++) {
              console.log(resData[i].algorithm_school_id, this.data[p].id)
              if (resData[i].algorithm_school_id == this.data[p].id) {
                this.data[p].chekced = `志愿${resData[i].position}`
              }
            }
          }
          this.data.forEach(item => {
            item.history = JSON.parse(item.history).reverse()
          })
          this.data.forEach(item => {
            item.history.unshift({
              'score_actual': item.score_actual,
              'score_danger': item.score_danger,
              'score_safe': item.score_safe,
              'score_guarantee': item.score_guarantee,
              'year': item.year,
              "province_line": item.province_line,
              'score_rank': item.score_rank,
              'enroll_plan': item.enroll_plan
            })
          })
          this.max_major_num = res.data.max_major_num
        })
      },
      /* 删除学校*/
      del_school(item, index) {
        this.$http.inventionSchoolDel({
          id: this.$route.query.id,
          a_school_id: item.algorithm_school_id
        }).then(res => {
          this.school.splice(index, 1)
          this.$message.success('删除学校成功')
        })
      },
      /* 跳转学校详情*/
      jump(item) {
        this.$router.push(`/schoolDetail?id=${item.school_id}`)
      },
      stop() {
        console.log('stop')
      },
      scoreShow(item, num) {
        if (num == 1) {
          this.oldscore = []
          this.oldscore = JSON.parse(item.history)
          this.score_show = true

        } else {
          let data = [{
            "year": item.year,
            "score_danger": item.score_danger,
            "score_safe": item.score_safe,
            "score_guarantee": item.score_guarantee
          }]
          this.forecastScore = data
          this.forecastScore_show = true
        }
      },
      showDropDown(show) {

      },
      range() {
        this.filterConditions.page = 1
        this.filterConditions.score_max = this.rangevalue[1]
        this.filterConditions.score_min = this.rangevalue[0]

        this.$http.checkSchoolCustomSearch(this.filterConditions).then(res => {
          this.data = res.data.list
          this.data.forEach(item => {
            item.history_list.reverse()
          })
          this.data.forEach(item => {
            item.history_list.unshift({
              'score_actual': item.score_actual,
              'score_danger': item.score_danger,
              'score_safe': item.score_safe,
              'score_guarantee': item.score_guarantee,
              'year': item.year,
              "province_line": item.province_line,
              'score_rank': item.score_rank,
              'enroll_plan': item.enroll_plan
            })
          })
        })
      },
      current_change(e) {
        this.zhuanye_page = e
        let data = {
          id: this.id,
          school_id: this.school_id,
          page: e,
          year: this.year
        }
        this.$http.checkMajorCustomSearch(data).then(res => {
          this.tableData = res.data
          this.zhuanye_total = res.data.total
          this.tableList = res.data.list
        })
      },
      surezhuanye(item) {
        this.zhuanye.push(item.mid + '')
        this.one_major.push(item)
        item.visible = false
      },
      /* 保存志愿，获取结果*/
      saveAll() {
        this.$http.checkSchool({
          id: this.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功')
            this.$router.push(`/form?id=${this.id}`)
            localStorage.setItem('activeurl', 'form')
          }
        })
      },
      /* 切换志愿优先级*/
      qiehuan(type) {
        this.filterConditions.page = 1
        this.onscroll = true
        if (type != '') {
          this.$http.getCustomSearch({
            mode: type,
            batch_name: this.filterConditions.batch_name
          }).then(res => {
            this.tab_select = res.data.list
            this.tab_type = type
          })
        } else {
          this.tab_type = 'school'
        }

      },
      editor(item) {
        this.id = item.id
        this.$http.customCheckDetail({
          id: this.id
        }).then(res => {
          res.data.result.map(item => {
            this.checkedId.push(item.school_id)
          })
          this.checkedSchool = res.data.result
          console.log(this.checkedId)
          this.$http.checkSchoolCustomSearch({
            id: this.id,
            batch_name: item.batch_name
          }).then(res => {
            this.data = res.data.list
            this.old = res.data.list
            this.data.forEach(item => {
              item.checked = false
            })
            this.add = false
          })
          this.$router.push(`/artificial?id=${this.id}`)
          this.$forceUpdate()
        })
      },
      del(item) {
        this.$http.del({
          id: item.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.$http.customCheckList().then(res => {
              this.record = res.data.list

            })
          }
        })

      },
      /* 添加新志愿*/
      addnew(item, index0, index) {
        if (this.school[index] != undefined && this.school.length > 0) {
          this.$confirm(`是否替换志愿${index+1}`, '志愿表替换提醒', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.data.forEach(item1 => {
              if (item1.id == this.school[index].algorithm_school_id) {
                item1.chekced = false
              }
              // if(item.id==this.school[index].algorithm_school_id)
              // if(item.id == this.school[index].algorithm_school_id)
            })
            this.checkedSchool.splice(this.checkedSchool.indexOf(this.school[index].algorithm_school_id), 1)
            item.chekced = '志愿' + (index + 1)
            item.major = []
            item.num = index + 1
            this.school_pos = index
            // this.school_id = item.id
            this.school[index] = item
            this.checkedSchool.push(item.id)
            let data = {
              "id": this.$route.query.id,
              "a_school_id": item.id,
              "pos": this.school_pos,
              "rate": item.rate
            }
            this.$http.inventionSchoolAdd(data).then(res => {
              this.$message({
                type: 'success',
                message: '替换成功!'
              })
              this.$forceUpdate()
            })
          }).catch(() => {

          });
        } else {
          item.chekced = '志愿' + (index + 1)
          item.major = []
          item.num = index
          item.position = index + 1
          this.school_pos = index + 1
          this.school.push(item)
          this.checkedSchool.push(item.id)
          this.school_id = item.id
          localStorage.setItem('custom', JSON.stringify(this.school))
          let data = {
            "id": this.$route.query.id,
            "a_school_id": item.id,
            "pos": this.school_pos,
            "rate": item.rate
          }
          this.$http.inventionSchoolAdd(data).then(res => {
            this.$message({
              type: 'success',
              message: '添加学校成功'
            })
          })
          // this.$forceUpdate()
        }
      },
      /* 筛选学校*/
      filter(e) {
        this.filterConditions = e
        this.filterConditions.page = 1
        e.batch_name = this.$route.query.batch
        this.$http.checkSchoolCustomSearch(e).then(res => {
          this.data = res.data.list
        })
      },
      /* 搜索学校*/
      searchSchool(e) {
        this.$http.checkSchoolCustomSearch({
          batch_name: this.$route.query.batch,
          school_name: e
        }).then(res => {
          this.data = res.data.list
        })
      },
      /* 清空搜索条件*/
      clear() {
        this.filterConditions.page = 1
        this.$http.checkSchoolCustomSearch(this.filterConditions).then(res => {
          this.data = res.data.list
          this.rangevalue = [res.data.score_min, res.data.score_max]
          this.marks = {
            300: res.data.score_min,
            500: res.data.score_max
          }
        })
        this.$http.checkSchoolSimulated().then(res => {
          this.options = res.data.list
        })
      },
      /* 保存选完专业的学校*/
      savezhuanye() {
        // let result = this.tableList.filter(item => {
        //   return item.checked == true
        // })
        let data = {
          major: this.one_major,
          school_pos: this.school_pos,
          id: this.id
        }
        if (this.zhuanye.length > 5) {
          this.$message.error('最多可填5个专业!')
          return
        }
        this.$http.aiMajorChange(data).then(res => {
          if (res.code == 200) {
            this.$message.success('保存成功!')
            this.popupshow = false
            this.tableList = []
            this.tableData = []
            setTimeout(() => {
              this.$http.customCheckDetail({
                id: this.id
              }).then(res => {
                this.data = res.data.result
                this.$forceUpdate()
              })
            })
          }
        })

      },
      /* 填报专业*/
      tianbaozhuanye(item) {
        if (this.checkMajor.indexOf(item.id) > -1) {
          this.$http.inventionMajorDelete({
            id: this.id,
            a_school_id: item.a_school_id,
            a_enroll_plan_id: item.id
          }).then(res => {
            item.checked = false
            this.checkMajor.splice(this.checkMajor.indexOf(item.id), 1)
            for (let i = 0; i < this.school.length; i++) {
              if (this.checkMajor.indexOf(this.school[i].major.id) == -1) {
                this.school[i].major.splice(i, 1)
              }
            }
          })
          return
        }
        if (this.checkMajor.length == this.max_major_num) {
          this.$message.error(`最多只能选择${this.max_major_num}个专业`)
          return
        }
        if (this.checkedSchool.indexOf(item.a_school_id) > -1) {
          this.school_id = item.a_school_id
        }
        if (this.school_id != item.a_school_id) {
          this.$message.error('请先选择院校')
          return
        }
        item.checked = true
        if (this.checkedSchool.indexOf(this.school_id) > -1) {
          for (let i = 0; i < this.school.length; i++) {
            if (this.school[i].algorithm_school_id == item.a_school_id) {
              this.school[i].major.push(item)
            }
          }
          this.checkMajor.push(item.id)
          let data = {
            "id": this.$route.query.id,
            "a_school_id": this.school_id,
            "a_enroll_plan_id": item.id,
            "pos": this.checkMajor.length,
            "rate": item.rate
          }
          this.$http.inventionMajorAdd(data).then(res => {

          })
        }
      },
      /* 删除志愿表中的专业*/
      del_zhuanye(item, index) {

        this.school[this.school_pos].major.splice(index, 1)
        let data = {
          id: this.id,
          a_school_id: item.a_school_id,
          a_enroll_plan_id: item.id
        }
        this.$http.inventionMajorDelete(data).then(res => {})
        this.$forceUpdate()
      },
      //查看招生计划
      lookplan(item, num) {
        this.$router.push(`/schoolDetail?id=${item.school_id}&activeName=second`)
      },
      /* 切换专业历史录取的年份 */
      tabchange(item, index) {
        let data = {
          id: this.id,
          school_id: this.school_id,
          year: item.label
        }
        this.year = item.label
        this.zhuanye_page = 1
        this.tableList = []
        this.$http.checkMajorCustomSearch(data).then(res => {
          this.tableList = res.data.list
          // this.tableList = res.data.list.map(item => {
          //   return item.checked == false
          // })
          this.tabindex = index
          // this.$forceUpdate()
        })
      },

      /* 点击展开专业*/
      tianbao(item, index) {
        this.tableData = item.major
      },
      change() {
        this.dialogTableVisible = true
      },
      open() {
        if (this.type == '展开志愿表') {
          this.type = '收起志愿表'
        } else {
          this.type = '展开志愿表'
        }

      },
      check(item) {
        this.batch = item.name
        this.options.forEach(item1 => {
          item1.checked = false
        })
        item.checked = true
      },
      sure() {
        // if (this.batch == '') {
        //   this.$message.warning('请先选择批次')
        //   return
        // }
        this.$http.customSchoolNew({
          batch: this.batch
        }).then(res => {
          this.id = res.data.id
          this.dialogTableVisible1 = false
          this.add = false
          this.$http.checkSchoolCustomSearch({
            id: this.id,
            batch_name: this.batch
          }).then(res => {
            this.data = res.data.list
            this.old = res.data.list
            this.data.forEach(item => {
              item.checked = false

            })
          })
          // this.$http.customCheckDetail({
          //   id: this.id
          // }).then(res => {
          //   this.school_pos = res.data.result.length
          //   this.checkedSchool = this.data.map(item => {
          //     return item.school_id
          //   })
          // })
          // this.$router.push(`/artificial?id=${this.id}`)
          this.add = false
        })
      },
      goDetail(item) {
        this.$router.push('/schoolDetail?id=' + item.school_id)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color:#C10B17;

  .checked_school_name {
    font-size: 18px;
    font-weight: bold;
  }

  .one1 {
    margin-top: 20px;
  }

  .score_table {
    width: 525px;
  }

  .history_data {
    display: inline-block;
    text-align: center;

    .line1 {

      // margin-top: 10px;
    }

    .line2 {
      height: 30px;
      margin: 5px 0;
      line-height: 30px;
      font-size: 13px;
    }
  }

  .content {
    position: fixed;
    right: 0;
    align-items: flex-start;
    z-index: 1111999;

    .zhuanye {
      width: 200px;
      border: 1px solid #ccc;
      // border-left: none;
      min-height: 244px;
      background-color: #FFFFFF;
      padding: 0 10px;
      border-top: none;
      max-height: 600px;
      overflow-y: scroll;

      p {

        word-break: break-word;
        // border-bottom: 1px solid #ccc;
        text-align: left;

        padding: 10px 0;
      }
    }

    .no {
      background-color: #C10B17;
      padding: 4px 6px;
      border-radius: 3px;
      color: #FFFFFF;
    }

    .content {
      position: fixed;
      top: 500px;
      right: 0;
    }

    .open {
      width: 46px;
      height: 244px;
      // background: #FFFFFF;
      border: 1px solid #C10B17;
      border-radius: 10px 0px 0px 10px;
      background: #C10B17;
      color: #FFFFFF;
      border-bottom-left-radius: 0px;
      cursor: pointer;

      .open1 {
        line-height: 15px;
        letter-spacing: 5px;
      }

      .save {
        display: inline-block;
        width: 100%;
        background-color: #FFFFFF;
        color: #C10B17;
        height: 50px;
        line-height: 25px;
        margin-top: 10px;
      }

      p {
        text-align: center;
        margin: 28px 0 25px 15px;
        writing-mode: vertical-lr
      }
    }
  }

  .zhuanye_one {
    padding: 20px 0px;
    border-bottom: 1px solid #CCCCCC;
    width: 100%;
    justify-content: space-between;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      color: #FFFFFF;
      background-color: #fff;
      color: #e9302d;
      border: 1px solid #e84c33;
    }
  }

  .tableone {
    width: 100%;

    // justify-content: space-between;
    &>div {
      margin-right: 20px;
    }

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      color: #FFFFFF;
    }
  }

  .nav {
    display: flex;
    width: 300px;
    align-items: flex-end;

    li {
      flex: 1;
      height: 40px;
      line-height: 40px;
      background: #F2F2F2;
      border-radius: 0px;
      position: relative;
      list-style: none;
    }
  }

  .lei {
    display: block;
    width: 24px;
    height: 24px;
    background-color: red;
    border-radius: 5px;
    color: #fff;
    line-height: 24px;
    margin-right: 7px;
    text-align: center;
    margin: 0 auto 10px auto;
  }

  .nav .item.active {
    height: 45px;
    background: $color;
  }

  .nav .item:first-child:before {
    content: '';
    display: none;
    width: 10px;
    height: 100%;
    background: $color;
    position: absolute;
    right: -5px;
    top: 0;
    z-index: 10;
    border-radius: 0 5px 0 0;
    transform: skew(10deg);
  }

  .nav .item:first-child.active:before {
    display: block;
  }

  .nav .item:last-child:before {
    content: '';
    display: none;
    width: 10px;
    height: 100%;
    background: $color;
    position: absolute;
    left: -5px;
    top: 0;
    z-index: 10;
    border-radius: 5px 0 0 0;
    transform: skew(-10deg);
  }

  .nav .item:last-child.active:before {
    display: block;
  }

  .add {
    width: 980px;
    height: 50px;
    line-height: 50px;
    background: #E8FAFA;
    border: 1px solid #19CACA;
    border-radius: 4px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #19CACA;
    text-align: center;
    cursor: pointer;
  }

  .batch {
    image {
      width: 28px !important;
      height: 22px;
    }

    .listone1 {
      margin: 10px 44px;
      border: 1px solid #E6E6E6;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 22px;
      text-align: left;

      text {
        font-size: 16px;
        color: #797373 !important;
        margin-right: 19px;
      }

      image {
        width: 14px;
        height: 25px;
      }

      .left1 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-top: 14px;
      }

      .left2 {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        margin: 19px 0 15px 0;
      }

      .left3 {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #19CACA;
      }
    }
  }

  .confirm {
    width: 558px;
    // height: 456px;
    background: #FFFFFF;
    border-radius: 10px;
    z-index: 1000;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -228px;

    button {
      width: 100px;
      height: 40px;
      background: #19CACA;
      border-radius: 20px;
      border: none;
      outline: none;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }

    .right_tip {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .form>div {
      margin-bottom: 34px;
      position: relative;

      span {
        width: 64px;
        height: 15px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }

    .form input {
      width: 387px;
      height: 41px;
      border: 1px solid #E6E6E6;
      border-radius: 20px;
      outline: none;
      margin-left: 38px;
      text-indent: 23px;
    }

    .head {
      margin: 47px 77px 44px 70px;

      span {
        display: inline-block;
        width: 50%;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
      }
    }
  }

  .form {
    padding-bottom: 40px;
  }

  .sure {
    width: 299px !important;
    height: 40px;
    background: #19CACA;
    border-radius: 20px;
    margin-top: 27px;
  }

  .selected {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333 !important;
  }

  .current1 {
    width: 600px;

    line-height: 46px;
    margin-bottom: 12px;
    text-align: left;
    border: 1px solid #EDEDED;



    span {
      display: inline-block;
      text-align: center;
      background-color: #F2F2F2;
    }



    .dangqian {
      width: 236px;
    }

    .change {
      display: inline-block;
      width: 200px;
      height: 46px;

      color: #666666;
    }

    .actived {
      background-color: #FFFFFF;
      color: $color;
    }
  }

  #mask {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 998;
    height: 100vh;
  }

  .tablemain {
    &>div {
      // flex: 1;
      text-align: center;
    }

    border-bottom: 1px solid #F2F2F2;
    padding: 18px 0;

    .shuju span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      background: rgba(207, 202, 204, 0.1);
      border: 1px solid #B0B0B0;
      color: #B0B0B0;
      border-radius: 5px;
    }

    .shuju1 span {
      display: block;
      margin: 5px auto;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border: 1px solid transparent;
      text-align: center;
      border-radius: 5px;
    }

    .btn {
      width: 74px;
      height: 32px;
      line-height: 32px;
      color: #ffffff;
      background: #19CACA;
      border-radius: 4px;
    }

    .info {

      text-align: center;

      img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
        margin-right: 15px;
      }
    }
  }

  .tablehead {
    text-align: left;
    position: sticky;
    top: 0;
    width: 1000px;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    // margin-top: 20px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
      // margin-right: 20px;
    }

    // & span:nth-child(2) {
    //   flex: 3
    // }

    // & span:nth-child(3) {
    //   flex: 2
    // }
  }

  main {
    // margin-top: 51px;

    .choosetype {
      text-align: left;

      .active {
        font-weight: 400;
        color: #19CACA;
        background: #D1F4F4;
      }

      span {
        display: inline-block;
        width: 107px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px 0px 0px 0px;
        border: 1px solid #F2F2F2;
        border-radius: 4px 0px 0px 0px;
        text-align: center;
      }
    }
  }

  .filter1 {
    justify-content: space-around;
    margin: 29px 20px;
  }

  .filter2 {
    justify-content: space-between;

    .clear {
      width: 60px;
      height: 36px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      color: #19CACA;
      background-color: #ffffff;
      color: #19CACA !important;
    }

    .flex {
      flex-wrap: nowrap;

      span {
        width: 100px
      }
    }

    margin: 0px 20px;
  }

  .right {
    margin-left: 16px;
  }

  .filter {
    width: 979px;
    // height: 149px;
    border: 1px solid #EDEDED;
    border-radius: 10px;
  }

  .score {
    width: 176px;
    height: 80px;
    border-radius: 6px;
    background-color: #E8FAFA;
    margin: 18px auto;
    line-height: 25px;
    color: #19CACA
  }

  .line {
    margin: 25px 0 18px 0;
    color: #19CACA
  }

  .info {
    // width: 205px;
    background: #FFFFFF;
    border-radius: 10px;
    margin-top: 18px;

    button {
      width: 177px;
      height: 33px;
      border: 1px solid #19CACA;
      border-radius: 6px;
      background-color: #FFFFFF;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #19CACA;
      margin-top: 15px;
    }

    &>p {
      width: 100%;
      text-align: left;
      margin: 20px 0px 20px 24px;
    }

    .head {
      height: 60px;
      background: #19CACA;
      border-radius: 10px;
      line-height: 60px;
      color: #FFFFFF;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
  }

  // .change {
  //   width: 205px;
  //   height: 151px;
  //   background: #FFFFFF;
  //   border: 1px solid #EDEDED;
  //   border-radius: 10px;

  //   p {
  //     width: 204px;
  //     height: 50px;
  //     line-height: 50px;
  //   }
  // }

  .hello {
    width: 1280px;
    margin: 20px auto;
    align-items: flex-start;
  }

  .active {
    background: #19CACA;
    color: #FFFFFF;

  }

  .type {
    // margin-top: 22px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;

    span {
      margin: 0 0px 5px 0;
    }
  }

  .name {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .major_name {
    font-size: 14px;
  }

  .address {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 10px;
  }

  .popuptitle {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #E6E6E6;
    text-indent: 40px;
  }

  .popup2 {
    width: 800px;
    height: 654px;
    background: #e8ffc9;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -400px;
    margin-top: -327px;
    overflow: hidden;
  }

  .caozuo {
    margin-top: 30px;
  }

  .popup1 {
    width: 1100px;
    padding-bottom: 40px;
    background: #ffffff;
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: -495px;
    margin-top: -327px;
    overflow: hidden;
    z-index: 999;

    .popuphead {
      width: 100%;
      line-height: 40px;
      height: 40px;
      border-bottom: 1px solid #E6E6E6;
      justify-content: space-between;

      p {
        margin-left: 20px;
      }

      i {
        margin-right: 20px;
      }
    }
  }

  .tableHead1 {
    width: 1000px;
    margin: 0 auto;
    height: 40px;
    background: #FAFAFA;
    border-radius: 4px;
    line-height: 40px;

  }

  .tabactive {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    background: #C10B17 !important;
  }

  .tableHead1 span {
    width: 120px;
    color: #999999;
  }

  .table1 {
    width: 100%;
    justify-content: space-around;
    margin-top: 40px;
  }

  .tableHead {
    margin-top: 40px;
    justify-content: space-between;
  }

  .checked {
    background: #C10B17 !important;
    border-radius: 4px;
    color: #ffffff !important;
  }
</style>
<style lang="scss">
  // 添加颜色类
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
    font-size: 16px
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
    font-size: 16px
  }

  .el-collapse-item__header {
    height: auto;
  }

  .el-collapse-item__arrow {
    display: none;
  }

  .el-slider__bar {
    background-color: #C10B17;
  }

  .el-slider__button {
    border: 2px solid #C10B17;
  }

  .el-dropdown-link span {}

  .el-dropdown-link {
    border-radius: 5px;
    background-color: #C10B17;
    display: inline-block;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    padding: 0 5px;
    background-color: #fff;
    color: #e9302d;
    border: 1px solid #e84c33;
  }

  .el-collapse-item__header {
    height: auto;
  }

  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/volunteer/ai.vue